<template>
  <div class="home">
    <!--头部-->
    <XDheader></XDheader>
    <div class="container">

      <!-- 主图轮播 -->
      <swiper></swiper>
      <div class="row">
        <div class="col-md-12 time" v-bind:class="themes_countdown">
          <h4 class="countdownTitle">距离比赛开始</h4>
          <XDcountdown size="25px"></XDcountdown>
        </div>
      </div>

      <!-- 新闻 -->
      <div class="row" style="margin: 15px -15px;">
          <div class="col-md-6">
            <div class="news">
              <div class="title" v-bind:class="themes_news_title"><i class="el-icon-tickets" style="margin:0 5px;"></i><span class="tl">赛事动态</span></div>
              <div class="content">
                <div class="row item" v-for='item in news' :key='item.id' @click="gotopath('/' + gameId + '/content/' + item.uuid)">
                  <div class="date col-md-2" v-bind:class="themes_news_date">
                    <span class="dd">{{ new Date(item.createtime) | moment("DD") }}</span>
                    <span class="mm">{{ new Date(item.createtime) | moment("YYYY-MM") }}</span>
                  </div>
                  <div class="ntitle col-md-10" v-bind:class="themes_news_name">
                      {{item.title}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" style="">
            <swiper v-if="swiperSliders.length>1" :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
              <swiper-slide v-for='(item,index) in swiperSliders'  :key='index' :style="{ 'background-image': 'url(' + item.cover + ')' }"></swiper-slide>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
            <swiper v-if="swiperSliders.length>1" :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
              <swiper-slide  v-for='(item,index) in swiperSliders' :key='index' :style="{ 'background-image': 'url(' + item.cover + ')' }"></swiper-slide>
            </swiper>
         </div>
      </div>
      <!--功能区-->
      <!-- 图文跳转链接 -->
      <div class="row fun-wrap">
        <div class="col-md-3"  v-for="fun in appweb.functions" :key="fun.func">
          <div class="fun" v-bind:class="themes_media_func" @click="gotopath('/' + gameId + '/func/'+fun.func)">
            <h4 style="margin:0">{{fun.func}}</h4>
          </div>
        </div>
      </div>

      <!--媒体合作伙伴区-->
      <XDmediaPartner></XDmediaPartner>
    </div>
      <XDfooter></XDfooter>
  </div>
</template>

<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      sliderImg: 1,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observeParents: true,
        observer: true
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        slideToClickedSlide: true,
        observeParents: true,
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      news: [],
      swiperSliders: []
    };
  },
  mounted() {
    // 倒计时
    this.getnews();
  },
  methods: {
    gotopath(path) {
      this.$router.push({ path });
    },
    goto(path) {
      if (path) {
        window.location.href = path;
      }
    },
    getnews() {
      api.homenews({ gameId: this.gameId }).then(({ data }) => {
        if (data.code === 0) {
          this.news = data.data;
          for (var i = 0; i < this.news.length; i++) {
            if (this.news[i].cover) {
              this.swiperSliders.push(this.news[i]);
            }
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    }
  },
  computed: {
    themes_countdown: function() {
      return "themes_countdown_" + this.$store.state.appweb.themetype;
    },
    themes_media_func: function() {
      return "themes_media_func_" + this.$store.state.appweb.themetype;
    },
    themes_partner_name: function() {
      return "themes_partner_name_" + this.$store.state.appweb.themetype;
    },
    themes_news_title: function() {
      return "themes_news_title_" + this.$store.state.appweb.themetype;
    },
    themes_news_date: function() {
      return "themes_news_date_" + this.$store.state.appweb.themetype;
    },
    themes_news_name: function() {
      return "themes_news_name_" + this.$store.state.appweb.themetype;
    },
    ...mapState(["appweb", "gameId", "match"]),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.fun-wrap {
  margin: 0px -15px !important;
}


.row {
  margin: 10px -1px;
  background: #fff;
}
.fun {
  border-radius: 5px;

  padding: 46px 8px;
  text-align: center;

  cursor: pointer;
}
.news .title {
  border-radius: 5px;
}
.news .item {
  background: #eee;
  margin: 6px 0;
  cursor: pointer;
}
.news .item[data-v-957c9522] {
  border-radius: 5px;
}
.news .item .date {
  text-align: center;
}
.news .item .date span {
  display: block;
}
.news .item .date span.dd {
  font-size: 30px;
  font-weight: bold;
}
.news .item .date span.mm {
  font-size: 15px;
}
.news .item .ntitle {
  padding: 23px 0px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div.title {
  padding: 20px 8px;
}
div.title span {
  font-size: 16px;
}
.news .item .col-md-3,
.col-md-4 {
  padding: 0;
}

.time {
  text-align: center;
}
.countdownTitle {
  padding: 10px;
}
img {
  border: 0;
  margin:10px;
}
.im img {
  margin-bottom: 5px;
  cursor: pointer;
  height: 107px;
}
.swiper-container {
  background-color: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
}
.slide {
  height: 330px;
}

.gallery-top {
  height: 70% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 30% !important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
.time[data-v-957c9522] {
  border-radius: 5px;
}
.gallery-top[data-v-957c9522] {
  border-radius: 5px 5px 0px 0px;
}

.gallery-thumbs[data-v-957c9522] {
  border-radius: 0px 0px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/template/home/2-home.vue